import React, { useState, useRef, useEffect } from "react";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import moment from "moment-timezone";
import TableRow from "@mui/material/TableRow";
import { Modal, Form, Button } from "react-bootstrap";
import ListGroup from "react-bootstrap/ListGroup";

const BetsCompetition = ({ betArr }) => {
    const [selectedBet, setSelectedBet] = useState({});
    const [show, setShow] = useState(false);
    const handleBetClose = () => setShow(false);

        console.log("atl betArr", betArr);

    return (
        <>
            <div className="col-md-12">
                <div className="custom-table-data mt-4">
                    <h4 className="dark-gray f-bold mb-4">
                      MultiLine  Bet Entries{" "}
                    </h4>
                    <TableContainer component={Paper}>
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Date</TableCell>
                                    <TableCell align="center">Bet ID</TableCell>
                                    <TableCell align="center">Bet Amt </TableCell>
                                    <TableCell align="center">Win Amt </TableCell>
                                    <TableCell align="center">Result </TableCell>
                                    <TableCell align="center">Actions </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {betArr.map((row) => (
                                    <TableRow
                                        key={row.name}
                                        sx={{
                                            "&:last-child td, &:last-child th": {
                                                border: 0,
                                            },
                                        }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {moment(row.createdDate).format("MM/DD/YYYY")}
                                        </TableCell>
                                        <TableCell align="center">
                                            {/* {row.betId} */}
                                            {row.id}
                                        </TableCell>
                                        <TableCell align="center">{row?.wager}</TableCell>
                                        <TableCell align="center">
                                            {row?.amount}
                                        </TableCell>
                                        <TableCell align="center">
                                            {row.defineresult}
                                        </TableCell>
                                        <TableCell align="center">
                                            <Button
                                                variant="primary"
                                                className="mrglft10"
                                                onClick={() => {
                                                    setShow(true);
                                                    setSelectedBet(row);

                                                }}
                                            >
                                                View
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
            {show && (
                <Modal
                    show={show}
                    onHide={handleBetClose}
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title-vcenter">
                            Player Details
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="col-md-12">
                            <TableContainer component={Paper}>
                                <Table
                                    size="small"
                                    aria-label="a dense table"
                                    stickyHeader
                                    aria-label="sticky table"
                                    sx={{ minWidth: 500 }}
                                    aria-label="custom pagination table"
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">
                                                Market ID
                                            </TableCell>
                                            <TableCell align="center">
                                                Stat Name
                                            </TableCell>
                                            <TableCell align="center">Match </TableCell>
                                            <TableCell align="center">
                                                Player Name
                                            </TableCell>
                                            <TableCell align="center">
                                                League Name
                                            </TableCell>
                                            <TableCell align="center">More</TableCell>
                                            <TableCell align="center">Less</TableCell>
                                            <TableCell align="center">Points</TableCell>
                                           <TableCell align="center">Multiplier</TableCell>
                                            <TableCell align="center">
                                                Final Score
                                            </TableCell>
                                            <TableCell align="center">Result </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {selectedBet.playerData.map((odd) => (
                                            <TableRow
                                                key={odd.idUser}
                                                sx={{
                                                    "&:last-child td, &:last-child th": {
                                                        border: 0,
                                                    },
                                                }}
                                            >
                                                <TableCell align="center">
                                                    {odd.marketId}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {odd.marketAbv}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {odd?.eventName}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {odd.name}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {odd.leagueName}
                                                </TableCell>
                                                <TableCell align="center">

                                                    {`${odd.isMore}`}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {" "}
                                                    {`${odd.isLess}`}
                                                </TableCell>
                                                <TableCell>{odd.points}</TableCell>
                                                <TableCell>{odd.multiplier}</TableCell>
                                                <TableCell align="center">
                                                    {odd.finalpoints}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {odd.defineresult}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleBetClose}>
                            Close
                        </Button>
                        {/* <Button variant="primary" onClick={handleClose}>
                  Save Changes
                </Button> */}
                    </Modal.Footer>
                </Modal>
            )}
        </>
    )
}

export default BetsCompetition